import { ProjectBase } from "../../project/models/project-base.model";
import { ProjectInfo } from "./project-info.model";
import { RDIncreaseinRDApplication } from "./increase-rd-application.model";
import { SbirApplication } from "./sbir-application.model";
import { LqreApplication } from "./lqre-application.model";
import { Lqre100Application } from "./lqre100-application.model";

export class Project extends ProjectBase {
  increaseInRD: RDIncreaseinRDApplication;
  lqre: LqreApplication;
  lqre100: Lqre100Application;
  sbir: SbirApplication;
  projectInfo: ProjectInfo;

  constructor() {
    super();
  }


  init(): Project {
    // Initialize the base class ProjectBase.
    super.init();

    // ProjectInfo in ProjectBase is type ProjectInfoBase.
    // So, Super.init() takes care of initializing ProjectInfoBase in ProjectBase.
    // Here we just use that initialized projectInfoBase and construct FilmProjectInfo.
    this.projectInfo = new ProjectInfo(this.projectInfo);

    if (this.increaseInRD) {
      this.increaseInRD = Object.assign(new RDIncreaseinRDApplication(), this.increaseInRD);
      this.increaseInRD.init();
    }

    if (this.lqre) {
      this.lqre = Object.assign(new LqreApplication(), this.lqre);
      this.lqre.init();
    }

    if (this.lqre100) {
      this.lqre100 = Object.assign(new Lqre100Application(), this.lqre100);
      this.lqre100.init();
    }

    if (this.sbir) {
      this.sbir = Object.assign(new SbirApplication(), this.sbir);
      this.sbir.init();
    }

    return this;
  }
}
